import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative h-[10px] shrink-0 rounded-full bg-gray-200" }
const _hoisted_2 = ["title"]

import { computed } from 'vue';
import type { TargetSource } from '@/types/MortalityObjective';
import { barFillPercent, barTickPercent } from './objectiveBar';
import { objectiveBarFillClass } from './objectiveDisplay';


export default /*@__PURE__*/_defineComponent({
  __name: 'ObjectiveBar',
  props: {
    currentValue: {},
    resolvedTarget: {},
    targetSource: {},
    ceiling: {}
  },
  setup(__props: any) {

const props = __props;

const fillPercent = computed(() => barFillPercent(props.currentValue, props.ceiling));
const tickPercent = computed(() => barTickPercent(props.resolvedTarget, props.ceiling));
const fillClass = computed(() => objectiveBarFillClass({ currentValue: props.currentValue, resolvedTarget: props.resolvedTarget }));
const tickClass = computed(() => (props.targetSource === 'Override' ? 'border-solid border-gray-700' : 'border-dashed border-gray-500'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["absolute inset-y-0 left-0 rounded-full", fillClass.value]),
      style: _normalizeStyle({ width: fillPercent.value + '%' })
    }, null, 6),
    _createElementVNode("div", {
      class: "absolute inset-y-0 flex w-2 -translate-x-1/2 items-center justify-center",
      style: _normalizeStyle({ left: tickPercent.value + '%' }),
      title: _ctx.$t('views.objectives.texts.targetTooltip', { value: _ctx.$n(_ctx.resolvedTarget, 'decimal') })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["h-[18px] w-0 border-l-2", tickClass.value])
      }, null, 2)
    ], 12, _hoisted_2)
  ]))
}
}

})